import { NormalizedReportItem } from '@modules/reports/basicReports/duck/utils';

import { moduleNamespace } from '../constants';

const namespace = moduleNamespace;

export const BASIC_REPORTS_RESPONSE = `${namespace}/REPORTS_RESPONSE`;
export const basicReportsResponse = (payload: {
  reports: NormalizedReportItem[];
  organizationGuid?: string;
  personGuid?: string;
}) => ({
  type: BASIC_REPORTS_RESPONSE,
  payload: {
    reports: payload.reports,
    guid: payload.organizationGuid || payload.personGuid,
  },
});

export const BASIC_REPORTS_ERROR = `${namespace}/REPORTS_ERROR`;
export const basicReportsError = (errorPayload: {
  error: unknown;
  organizationGuid?: string;
  personGuid?: string;
}) => ({
  type: BASIC_REPORTS_ERROR,
  payload: {
    error: errorPayload.error,
    guid: errorPayload.organizationGuid || errorPayload.personGuid,
  },
});

export const OPEN_SELECT_YOUTH_MODAL = `${namespace}/OPEN_SELECT_YOUTH_MODAL`;
export const openSelectYouthModal = (reportCode: string) => ({
  type: OPEN_SELECT_YOUTH_MODAL,
  payload: reportCode,
});
export const CLOSE_SELECT_YOUTH_MODAL = `${namespace}/CLOSE_SELECT_YOUTH_MODAL`;
export const closeSelectYouthModal = () => ({ type: CLOSE_SELECT_YOUTH_MODAL });
